import React, { Component } from 'react';
import { Section } from './ui/Section';
import { useMetaPixelViewTracking, trackEvent } from '../utils/metaPixel';
export function Pricing() {
  useMetaPixelViewTracking('pricing', {
    content_category: 'pricing',
    content_type: 'product'
  });
  const baseComponents = [{
    name: 'Colección 6 Tomos del Instructor PRO',
    value: '67€'
  }, {
    name: '6 Bonos Exclusivos (Toolbox PRO)',
    value: '47€'
  }];
  const completeComponents = [{
    name: 'Colección 6 Tomos del Instructor PRO',
    value: '67€'
  }, {
    name: '6 Bonos Exclusivos (Toolbox PRO)',
    value: '47€'
  }, {
    name: 'SALA LLENA 365D — Sistema de Retención y Negocio',
    value: '47€'
  }];
  const salaLlenaModules = [{
    icon: '📅',
    title: 'Protocolo de 12 Meses',
    desc: 'El calendario estratégico completo para nunca tener un mes malo'
  }, {
    icon: '🛡️',
    title: 'Sistema de Retención 365',
    desc: 'Psicología aplicada para que ningún alumno abandone sin que lo veas venir'
  }, {
    icon: '💼',
    title: 'Plan de Negocio del Autónomo',
    desc: 'Fórmula de precio, contrato de matrícula y modelo de escalabilidad'
  }, {
    icon: '📣',
    title: 'Motor de Recomendación',
    desc: 'El sistema para que tus alumnos te traigan nuevos alumnos sin que se lo pidas'
  }];
  const handlePackClick = (packName: string, price: string) => {
    trackEvent('InitiateCheckout', {
      content_name: packName,
      value: parseFloat(price),
      currency: 'EUR'
    });
  };
  return <Section id="pricing" data-id="element-179">
      <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-3 text-brand-title" data-id="element-180">
        💰 Oferta Especial de Lanzamiento
      </h2>
      <p className="text-center text-brand-subtitle font-heading font-bold text-xl mb-8" data-id="element-181">
        ⭐ ELIGE TU OPCIÓN
      </p>

      <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto mb-8" data-id="element-182">
        {/* Base Pack */}
        <div className="bg-white border-2 border-brand-border rounded-3xl p-6 shadow-card hover:shadow-card-hover transition-all" data-id="element-183">
          <h3 className="font-heading text-2xl font-bold text-brand-subtitle mb-4 text-center" data-id="element-184">
            OPCIÓN 1 — MANUAL COMPLETO
          </h3>

          <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-185">
            ← Scroll to see full table →
          </div>

          <div className="overflow-x-auto mb-4" data-id="element-186">
            <table className="w-full min-w-[280px] border-collapse bg-brand-bgAlt rounded-xl overflow-hidden border border-brand-border" data-id="element-187">
              <thead data-id="element-188">
                <tr className="border-b border-brand-border" data-id="element-189">
                  <th className="text-left p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-190">
                    Componente
                  </th>
                  <th className="text-right p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-191">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-192">
                {baseComponents.map((component, i) => <tr key={i} className="border-b border-brand-border last:border-0 bg-white" data-id="element-193">
                    <td className="p-3 font-body text-brand-text text-sm" data-id="element-194">
                      {component.name}
                    </td>
                    <td className="p-3 text-right font-heading font-semibold text-brand-subtitle" data-id="element-195">
                      {component.value}
                    </td>
                  </tr>)}
                <tr className="bg-brand-bgAlt font-bold" data-id="element-196">
                  <td className="p-3 font-heading text-brand-subtitle" data-id="element-197">
                    VALOR TOTAL
                  </td>
                  <td className="p-3 text-right font-heading text-brand-title text-lg" data-id="element-198">
                    114€
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="text-center mb-4" data-id="element-199">
            <div className="font-body text-brand-textMuted text-lg mb-2 line-through" data-id="element-200">
              114€
            </div>
            <div className="font-body text-brand-text text-sm mb-2" data-id="element-201">
              PRECIO HOY (88% OFF):
            </div>
            <div className="font-heading text-5xl font-black text-brand-title mb-3" data-id="element-202">
              🏆 13,99€
            </div>
            <p className="font-body text-brand-text text-sm mb-4" data-id="element-203">
              Pago único. Acceso inmediato. Sin suscripción.
            </p>
          </div>

          <a href="https://www.digipromarket.com/cart/56615758725446:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Manual Completo', '13.99')} className="font-heading w-full bg-gradient-red hover:opacity-90 text-white font-bold text-lg py-4 px-6 rounded-2xl transition-all hover:scale-[1.02] active:scale-[0.98] text-center block shadow-red-glow mb-3 tracking-wide" data-id="element-204">
            🚀 SÍ, QUIERO EL MANUAL COMPLETO →
          </a>

          <div className="text-center space-y-1 text-xs text-brand-textMuted tracking-wide" data-id="element-205">
            <div data-id="element-206">
              ⚡ Acceso Inmediato • 💳 Un Solo Pago • 🛡️ Garantía 7 Días
            </div>
          </div>
        </div>

        {/* Complete Pack */}
        <div className="bg-white border-2 border-brand-cta rounded-3xl p-6 shadow-red-glow-lg relative transform md:-translate-y-4" data-id="element-207">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-gradient-red text-white font-heading font-bold px-4 py-1 rounded-full text-sm whitespace-nowrap shadow-red-glow tracking-wider" data-id="element-208">
            ⭐ LA MÁS ELEGIDA
          </div>

          <h3 className="font-heading text-2xl font-bold text-brand-subtitle mb-4 text-center" data-id="element-209">
            OPCIÓN 2 — PACK MAESTRO COMPLETO
          </h3>

          <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-210">
            ← Scroll to see full table →
          </div>

          <div className="overflow-x-auto mb-4" data-id="element-211">
            <table className="w-full min-w-[280px] border-collapse bg-brand-bgAlt rounded-xl overflow-hidden border border-brand-border" data-id="element-212">
              <thead data-id="element-213">
                <tr className="border-b border-brand-border" data-id="element-214">
                  <th className="text-left p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-215">
                    Componente
                  </th>
                  <th className="text-right p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-216">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-217">
                {completeComponents.map((component, i) => <tr key={i} className="border-b border-brand-border last:border-0 bg-white" data-id="element-218">
                    <td className="p-3 font-body text-brand-text text-sm" data-id="element-219">
                      {component.name}
                    </td>
                    <td className="p-3 text-right font-heading font-semibold text-brand-subtitle" data-id="element-220">
                      {component.value}
                    </td>
                  </tr>)}
                <tr className="bg-brand-bgAlt font-bold" data-id="element-221">
                  <td className="p-3 font-heading text-brand-subtitle" data-id="element-222">
                    VALOR TOTAL
                  </td>
                  <td className="p-3 text-right font-heading text-brand-title text-lg" data-id="element-223">
                    161€
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div className="text-center mb-4" data-id="element-224">
            <div className="font-body text-brand-textMuted text-lg mb-2 line-through" data-id="element-225">
              161€
            </div>
            <div className="font-body text-brand-text text-sm mb-2" data-id="element-226">
              PRECIO HOY (88% OFF):
            </div>
            <div className="font-heading text-5xl font-black text-brand-title mb-3" data-id="element-227">
              🏆 19,99€
            </div>
            <p className="font-body text-brand-text text-sm mb-4" data-id="element-228">
              Todo el ecosistema completo. Pago único. Acceso inmediato.
            </p>
          </div>

          <a href="https://www.digipromarket.com/cart/56615759708486:1" target="_blank" rel="noopener noreferrer" onClick={() => handlePackClick('Pack Maestro Completo', '19.99')} className="font-heading w-full bg-gradient-red hover:opacity-90 text-white font-bold text-lg py-4 px-6 rounded-2xl transition-all hover:scale-[1.02] active:scale-[0.98] text-center block shadow-red-glow mb-3 tracking-wide" data-id="element-229">
            🚀 SÍ, QUIERO EL PACK MAESTRO COMPLETO →
          </a>

          <div className="text-center space-y-1 text-xs text-brand-textMuted tracking-wide mb-4" data-id="element-230">
            <div data-id="element-231">
              ⚡ Acceso Inmediato • 💳 Un Solo Pago • 🛡️ Garantía 7 Días
            </div>
          </div>

          <div className="border-t border-brand-border pt-4" data-id="element-232">
            <h4 className="font-heading font-bold text-brand-subtitle text-center mb-3" data-id="element-233">
              ¿Qué incluye SALA LLENA 365D?
            </h4>
            <div className="text-center text-sm text-brand-textMuted mb-4 md:hidden tracking-wide" data-id="element-234">
              ← Scroll to see full table →
            </div>
            <div className="overflow-x-auto" data-id="element-235">
              <table className="w-full min-w-[280px] border-collapse bg-brand-bgAlt rounded-xl overflow-hidden border border-brand-border" data-id="element-236">
                <thead data-id="element-237">
                  <tr className="border-b border-brand-border" data-id="element-238">
                    <th className="text-left p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-239">
                      Módulo
                    </th>
                    <th className="text-left p-3 font-heading font-bold text-brand-subtitle text-sm tracking-wide uppercase" data-id="element-240">
                      Contenido
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-241">
                  {salaLlenaModules.map((module, i) => <tr key={i} className="border-b border-brand-border last:border-0 bg-white" data-id="element-242">
                      <td className="p-3 text-2xl" data-id="element-243">{module.icon}</td>
                      <td className="p-3" data-id="element-244">
                        <div className="font-heading font-bold text-brand-subtitle text-sm mb-1" data-id="element-245">
                          {module.title}
                        </div>
                        <div className="font-body text-brand-text text-xs" data-id="element-246">
                          {module.desc}
                        </div>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Section>;
}